module.exports = __webpack_public_path__ + "img/Wen_Li@2x.6a9d7a32.png";